import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Button, Box } from "biologiatotal-ui";

import "./finish.scss";

class Finish extends Component {
  constructor(props) {
    super(props);

    this.goToPlatform = this.goToPlatform.bind(this);
  }

  goToPlatform() {
    const { history } = this.props;

    history.replace("/");
  }

  billetResult(email) {
    return (
      <Fragment>
        <span className="finish-panel-title">PRONTO!</span>
        <p className="finish-panel-text">
          Seu boleto foi enviado para o email <strong>{email}</strong>
        </p>
        <p className="finish-panel-text">
          Devido ao tempo de processamento dos boletos, o banco pode levar até 3 dias úteis para reconher o pagamento e
          nos informar.
        </p>
        <p className="finish-panel-text">
          Até lá, você terá acesso aos itens gratuitos da plataforma e após receber a confirmação, liberamos seu acesso
          completo!
        </p>
        <Button className="finish-panel-button" large gradientLink onClick={this.goToPlatform}>
          ACESSAR PLATAFORMA
        </Button>
      </Fragment>
    );
  }

  cardResult(lastPurchase, expiration) {
    const status = lastPurchase.status || lastPurchase.current_status;

    switch (status) {
      case "paid":
      case "processing":
      case "pending": {
        return (
          <Fragment>
            <span className="finish-panel-title">PRONTO!</span>
            <p className="finish-panel-text">
              Assim que o seu pagamento for identificado você já poderá acessar a plataforma com todos os conteúdos
              liberados.
            </p>
            <p className="finish-panel-text">Até lá, você terá acesso aos itens gratuitos da plataforma!</p>
            {/*<p className="finish-panel-text">
              Seu plano expira no dia <strong>{expiration}</strong>
            </p>*/}
            <Button className="finish-panel-button" large gradientLink onClick={this.goToPlatform}>
              ACESSAR PLATAFORMA
            </Button>
          </Fragment>
        );
      }

      default: {
        return (
          <Fragment>
            <span className="finish-panel-title">PROBLEMAS NO PAGAMENTO!</span>
            <p className="finish-panel-text">Não foi possível concluir o seu pagamento.</p>
            <p className="finish-panel-text">Tente novamente ou escolha outra forma de cobrança!</p>
            <Button className="finish-panel-button" large link onClick={() => this.props.history.push("/pagamento")}>
              VOLTAR PARA O PAGAMENTO
            </Button>
          </Fragment>
        );
      }
    }
  }

  render() {
    const { user, data } = this.props;
    const billet = data.lastPurchase.payment_method === "boleto";

    return (
      <div className="columns finish-panel">
        <div className="column centered is-12-mobile is-8-tablet is-6-desktop is-4-widescreen is-offset-2-tablet is-offset-3-desktop is-offset-4-widescreen">
          <Box className="finish-panel-content">
            {billet ? this.billetResult(user.email) : this.cardResult(data.lastPurchase)}
          </Box>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    ...state.account,
    user: state.app.data.user
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

const Routered = withRouter(connect(mapStateToProps, mapDispatchToProps)(Finish));

Routered.displayName = "Finish";

export default Routered;
